import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const HeaderCloseButton = (props) => {
    return (_jsx(React.Fragment, { children: _jsx("button", { id: "wiki-closebtn", className: "fa-regular fa-circle-xmark", onClick: props.toggleWiki }) }));
};
